/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';
function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
export function dateComparator(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  if (isNaN(d1) && isNaN(d2)) return 0;
  if (isNaN(d1)) return -1;
  if (isNaN(d2)) return 1;

  return d1 - d2;
}
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
// grid on first Scren
export const ManufactureTableHead = [
  {
    headerName: 'Select All',
    maxWidth: 135,
    headerCheckboxSelection: false, // For header check box
    filter: false,
    resizable: true,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: false,
    checkboxSelection: true,
    pdfExportOptions: {
      skipColumn: true,
    },
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const AllManufactureTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    //sortable: true,
    sort: 'asc',
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_180,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_230,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    comparator: comparatorQtr,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Codes',
    field: 'dispute_cd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    // resizable: true,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    wrapText: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Balance Due',
    field: 'disputeUnitsRebateAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Date Initiated',
    field: 'initiatedDT',
    editable: false,
    sortable: true,
    suppressMenu: false,
    comparator: dateComparator,
    resizable: true,
    minWidth: Styles.Width_125,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Date Assigned',
    field: 'assignedDT',
    editable: false,
    sortable: true,
    comparator: dateComparator,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Resolved Date',
    field: 'resolvedDT',
    editable: false,
    sortable: true,
    comparator: dateComparator,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Recap Mailout',
    field: 'recapMailoutDT',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Assigned User',
    field: 'assignedUserID',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const DisputeCodesSelected = [
  {
    headerName: 'Select All',
    maxWidth: 135,
    headerCheckboxSelection: true, // For header check box
    filter: false,
    resizable: true,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: false,
    pdfExportOptions: {
      skipColumn: true,
    },
    checkboxSelection: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Code',
    field: 'codeValuetemp',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    maxWidth: 120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Short Desc',
    field: 'shortDescription',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Long Desc',
    field: 'longDescription',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_330,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
